<template>
  <div>
    <div class="cl-666">404找不到页面。。。</div>
  </div>
</template>
<style>
</style>
<script>
export default {
  name: 'Error',
  components: {},
  data() {
    return {
      msg: 'hello vue'
    }
  }
}
</script>
